import React from 'react';

export default function Speedcubing() {
	return (
		<div className="w-full">
			<div className="hero min-h-screen w-full">
				<div className="hero-content flex-col lg:flex-row lg:space-x-20 text-left">
					<div className="w-3/4">
						<h1 className="text-5xl font-bold text-center">Speedcubing</h1>
						<p className="py-6">
							I started Speedcubing in 2014, but only started going for competitions in 2018.
							I still do it pretty regularly, but am kinda washed now.
							My favourite event is 4x4 (sub 40), and the other big cubes.
						</p>
						<div className="flex md:flex-row flex-wrap md:space-x-3 justify-center flex-col items-center space-y-10 md:space-y-3">
							<a className="card bg-base-100 shadow-xl min-w-fit" href="https://www.worldcubeassociation.org/persons/2018HINN01">
								<div className="card-body">
									<div className="card-title">
										<img className="h-10 rounded" src="data:image/png;base64,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" />
										World Cube Association
									</div>
									<p>18 Competitions</p>
									<p>485 Completed Solves</p>
								</div>
							</a>
						</div>
						<div className="py-5 personal-records">
							<h3 className="text-3xl font-bold text-center">Current Personal Records caa 17/09/24</h3>
							<div class="table-responsive">
								<table class="table table-striped">
									<thead>
										<tr>
											<th class="event">Event</th>
											<th class="country-rank"><abbr title="National Rank">NR</abbr></th>
											<th class="continent-rank"><abbr title="Continental Rank">CR</abbr></th>
											<th class="world-rank"><abbr title="World Rank">WR</abbr></th>
											<th class="single">Single</th>
											<th class="average">Average</th>
											<th class="world-rank"><abbr title="World Rank">WR</abbr></th>
											<th class="continent-rank"><abbr title="Continental Rank">CR</abbr></th>
											<th class="country-rank"><abbr title="National Rank">NR</abbr></th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td class="event" data-event="333">
												<i class=" cubing-icon icon event-333"></i>
												3x3x3 Cube
											</td>
											<td class="country-rank ">100</td>
											<td class="continent-rank ">3591</td>
											<td class="world-rank ">10281</td>
											<td class="single">
												<a class="plain" href="/results/rankings/333/single">
													9.12
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/333/average">
													11.41
												</a>            </td>
											<td class="world-rank ">11497</td>
											<td class="continent-rank ">4158</td>
											<td class="country-rank ">119</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="222">
												<i class=" cubing-icon icon event-222"></i>
												2x2x2 Cube
											</td>
											<td class="country-rank ">146</td>
											<td class="continent-rank ">4693</td>
											<td class="world-rank ">17906</td>
											<td class="single">
												<a class="plain" href="/results/rankings/222/single">
													2.87
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/222/average">
													3.79
												</a>            </td>
											<td class="world-rank ">8317</td>
											<td class="continent-rank ">2201</td>
											<td class="country-rank ">88</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="444">
												<i class=" cubing-icon icon event-444"></i>
												4x4x4 Cube
											</td>
											<td class="country-rank ">19</td>
											<td class="continent-rank ">453</td>
											<td class="world-rank ">1397</td>
											<td class="single">
												<a class="plain" href="/results/rankings/444/single">
													29.96
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/444/average">
													34.45
												</a>            </td>
											<td class="world-rank ">1282</td>
											<td class="continent-rank ">431</td>
											<td class="country-rank ">17</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="555">
												<i class=" cubing-icon icon event-555"></i>
												5x5x5 Cube
											</td>
											<td class="country-rank ">32</td>
											<td class="continent-rank ">869</td>
											<td class="world-rank ">2568</td>
											<td class="single">
												<a class="plain" href="/results/rankings/555/single">
													1:07.51
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/555/average">
													1:17.01
												</a>            </td>
											<td class="world-rank ">2872</td>
											<td class="continent-rank ">984</td>
											<td class="country-rank ">34</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="666">
												<i class=" cubing-icon icon event-666"></i>
												6x6x6 Cube
											</td>
											<td class="country-rank ">30</td>
											<td class="continent-rank ">551</td>
											<td class="world-rank ">1716</td>
											<td class="single">
												<a class="plain" href="/results/rankings/666/single">
													2:10.20
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/666/average">
													2:20.87
												</a>            </td>
											<td class="world-rank ">1774</td>
											<td class="continent-rank ">568</td>
											<td class="country-rank ">32</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="777">
												<i class=" cubing-icon icon event-777"></i>
												7x7x7 Cube
											</td>
											<td class="country-rank ">33</td>
											<td class="continent-rank ">839</td>
											<td class="world-rank ">2564</td>
											<td class="single">
												<a class="plain" href="/results/rankings/777/single">
													3:48.00
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/777/average">
													3:57.59
												</a>            </td>
											<td class="world-rank ">2390</td>
											<td class="continent-rank ">788</td>
											<td class="country-rank ">33</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="333oh">
												<i class=" cubing-icon icon event-333oh"></i>
												3x3x3 One-Handed
											</td>
											<td class="country-rank ">43</td>
											<td class="continent-rank ">1618</td>
											<td class="world-rank ">4566</td>
											<td class="single">
												<a class="plain" href="/results/rankings/333oh/single">
													15.23
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/333oh/average">
													20.30
												</a>            </td>
											<td class="world-rank ">6030</td>
											<td class="continent-rank ">2258</td>
											<td class="country-rank ">58</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="clock">
												<i class=" cubing-icon icon event-clock"></i>
												Clock
											</td>
											<td class="country-rank ">43</td>
											<td class="continent-rank ">881</td>
											<td class="world-rank ">3945</td>
											<td class="single">
												<a class="plain" href="/results/rankings/clock/single">
													8.97
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/clock/average">
													11.02
												</a>            </td>
											<td class="world-rank ">4119</td>
											<td class="continent-rank ">889</td>
											<td class="country-rank ">40</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="minx">
												<i class=" cubing-icon icon event-minx"></i>
												Megaminx
											</td>
											<td class="country-rank ">37</td>
											<td class="continent-rank ">984</td>
											<td class="world-rank ">3531</td>
											<td class="single">
												<a class="plain" href="/results/rankings/minx/single">
													1:08.49
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/minx/average">
													1:13.07
												</a>            </td>
											<td class="world-rank ">2960</td>
											<td class="continent-rank ">830</td>
											<td class="country-rank ">32</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="pyram">
												<i class=" cubing-icon icon event-pyram"></i>
												Pyraminx
											</td>
											<td class="country-rank ">170</td>
											<td class="continent-rank ">6579</td>
											<td class="world-rank ">24598</td>
											<td class="single">
												<a class="plain" href="/results/rankings/pyram/single">
													6.55
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/pyram/average">
													8.40
												</a>            </td>
											<td class="world-rank ">15775</td>
											<td class="continent-rank ">4533</td>
											<td class="country-rank ">125</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="skewb">
												<i class=" cubing-icon icon event-skewb"></i>
												Skewb
											</td>
											<td class="country-rank ">47</td>
											<td class="continent-rank ">2131</td>
											<td class="world-rank ">8248</td>
											<td class="single">
												<a class="plain" href="/results/rankings/skewb/single">
													4.58
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/skewb/average">
													7.03
												</a>            </td>
											<td class="world-rank ">7174</td>
											<td class="continent-rank ">2023</td>
											<td class="country-rank ">51</td>
											<td></td>
										</tr>
										<tr>
											<td class="event" data-event="sq1">
												<i class=" cubing-icon icon event-sq1"></i>
												Square-1
											</td>
											<td class="country-rank ">38</td>
											<td class="continent-rank ">942</td>
											<td class="world-rank ">4169</td>
											<td class="single">
												<a class="plain" href="/results/rankings/sq1/single">
													17.40
												</a>            </td>
											<td class="average">
												<a class="plain" href="/results/rankings/sq1/average">
													24.34
												</a>            </td>
											<td class="world-rank ">4364</td>
											<td class="continent-rank ">1013</td>
											<td class="country-rank ">42</td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div >
	)
}